<app-identification-search
  [action]="action"
  (selectIdentificationId)="onSelectIdentificationId($event)"
  (searchCompleted)="onSearchCompleted()"
></app-identification-search>
<app-identification-search-result
  [data]="searchResultDetail"
  [searchResultType]="searchResultType"
  (doResetSearch)="onDoResetSearch($event)"
>
</app-identification-search-result>
